import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/open.png'
import _imports_1 from '@/assets/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "expand-bar"
}
const _hoisted_3 = { class: "border-btn" }
const _hoisted_4 = {
  key: 1,
  class: "title"
}

import { isExpand } from "@/views/Home/useData/useHomePage";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeftHeader',
  setup(__props) {

const toolTips = computed(() => {
  return isExpand.value ? "收起侧边栏" : "打开侧边栏";
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isExpand))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tag" }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "center-title" }, "AI对话", -1)),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: toolTips.value,
            placement: "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_0,
                  height: "18",
                  width: "18",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpand.value = !_unref(isExpand)))
                })
              ])
            ]),
            _: 1
          }, 8, ["content"])
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "deep R1满血版"))
      : _createCommentVNode("", true),
    (!_unref(isExpand))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "compact-mode",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isExpand.value = !_unref(isExpand)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_1,
            class: "logo",
            alt: ""
          }, null, -1)),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: toolTips.value,
            placement: "right"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "border-btn" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  height: "18",
                  width: "18"
                })
              ], -1)
            ])),
            _: 1
          }, 8, ["content"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})